import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryInvoiceChargeItem(requestBody) {
  return request({
    url: URL.act.invoiceChargeItem.queryUrl,
    method: 'post',
    data: requestBody
  })
}

export function saveInvoiceChargeItem(requestBody) {
  return request({
    url: URL.act.invoiceChargeItem.saveUrl,
    method: 'post',
    data: requestBody
  })
}

export function deleteInvoiceChargeItem(requestBody) {
  return request({
    url: URL.act.invoiceChargeItem.deleteUrl,
    method: 'post',
    data: requestBody
  })
}
